import { memo } from "react";
import styled from "styled-components";
import { usePost, usePostValue } from "../../..";
import { api, apiRoutes } from "../../../../../api";
import { DPButton } from "../../../../../common/types";
import SubscribeButtonC from "../../../../../components/SubscribeButtonC";
import { useStateReducer } from "../../../../../hooks/useStateReducer";

interface Props extends DPButton {}

const SubscribeButton = (props: Props) => {
  const [state, setState] = useStateReducer({ isLoading: false });

  const { setOne: setPostOne } = usePost();
  const isSubscribed = usePostValue((s) => s.post.isSubscribed);
  const createdById = usePostValue((s) => s.post.createdBy._id);

  const handleClick = async () => {
    try {
      setState({ isLoading: true });
      const { data } = await api.patch(apiRoutes.patchSubscribe(createdById));
      setPostOne("post", (v) => ({
        ...v,
        isSubscribed: data.isSubscribed,
        createdBy: { ...v.createdBy, subsCount: data.subsCount },
      }));
    } catch (err) {
    } finally {
      setState({ isLoading: false });
    }
  };

  return (
    <SubscribeButtonC
      onClick={handleClick}
      className={props.className}
      disabled={state.isLoading}
      isSubscribed={isSubscribed}
    />
  );
};

export default styled(memo(SubscribeButton))``;
